import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) return;

      $( '.mission-scroll' ).each( function( key, val ) {
        const line = $( this ).find( '.line' )[0];
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 60%',
            end: 'bottom 60%',
            scrub: 1,
            // markers: true,
          },
        } );
        tl.to( line, {scaleY: '1', ease: 'linear'}, 0 );
      } );

      $( '.mission-scroll__large-heading-panel' ).each( function( key, val ) {
        const heading = $( this ).find( '.mission-scroll__large-heading' )[0];

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 1,
            // markers: true,
          },
        } );
        tl.to( heading, {scale: '1.1', ease: 'linear', delay: 0, duration: 0.4}, 0 );
        tl.to( heading, {scale: '1', ease: 'linear', delay: 0.6, duration: 0.4}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'mission-scroll', COMPONENT );
} )( app );
